import { TICK_RATE } from "./balance.js";
export const BOSS_EFFECT_DEFINITIONS = {
    surge: { kind: "surge", family: "mobs", durationTicks: 0, label: "Surge" },
    bloodlust: { kind: "bloodlust", family: "mobs", durationTicks: 8 * TICK_RATE, label: "Bloodlust" },
    reinforcement: {
        kind: "reinforcement",
        family: "mobs",
        durationTicks: 0,
        label: "Reinforcement",
    },
    echo: { kind: "echo", family: "mobs", durationTicks: 0, label: "Echo" },
    frostbite: { kind: "frostbite", family: "towers", durationTicks: 10 * TICK_RATE, label: "Frostbite" },
    static_field: {
        kind: "static_field",
        family: "towers",
        durationTicks: 10 * TICK_RATE,
        label: "Static Field",
    },
    curse: { kind: "curse", family: "towers", durationTicks: 5 * TICK_RATE, label: "Curse" },
    shadow_veil: {
        kind: "shadow_veil",
        family: "towers",
        durationTicks: 15 * TICK_RATE,
        label: "Shadow Veil",
    },
    soul_drain: { kind: "soul_drain", family: "economy", durationTicks: 0, label: "Soul Drain" },
    wrath: { kind: "wrath", family: "economy", durationTicks: 12 * TICK_RATE, label: "Wrath" },
};
export const ICOSAHEDRON_BOSS = {
    id: "icosahedron",
    label: "Icosahedron",
    hpMaxByDifficulty: {
        normal: 5_000,
        heroic: 9_500,
        nightmare: 15_000,
    },
    phases: [
        {
            index: 0,
            hpThresholdPct: 100,
            effectIntervalTicks: 30 * TICK_RATE,
            maxConcurrentEffects: 1,
            preferredFamilies: ["mobs", "towers", "economy"],
            passiveDamagePerFailedWave: 0,
        },
        {
            index: 1,
            hpThresholdPct: 75,
            effectIntervalTicks: 25 * TICK_RATE,
            maxConcurrentEffects: 1,
            preferredFamilies: ["towers"],
            passiveDamagePerFailedWave: 0,
        },
        {
            index: 2,
            hpThresholdPct: 50,
            effectIntervalTicks: 20 * TICK_RATE,
            maxConcurrentEffects: 2,
            preferredFamilies: ["mobs"],
            passiveDamagePerFailedWave: 0,
        },
        {
            index: 3,
            hpThresholdPct: 25,
            effectIntervalTicks: 15 * TICK_RATE,
            maxConcurrentEffects: 2,
            preferredFamilies: ["mobs", "economy"],
            passiveDamagePerFailedWave: 1,
        },
    ],
    effectPool: [
        "surge",
        "bloodlust",
        "reinforcement",
        "echo",
        "frostbite",
        "static_field",
        "curse",
        "shadow_veil",
        "soul_drain",
        "wrath",
    ],
};
const BOSS_REGISTRY = {
    [ICOSAHEDRON_BOSS.id]: ICOSAHEDRON_BOSS,
};
export function getBossDefinition(id) {
    return BOSS_REGISTRY[id] ?? null;
}
export function getBossEffectDefinition(kind) {
    return BOSS_EFFECT_DEFINITIONS[kind];
}
export const BOSS_TRIBUTE_BASE = 70;
export const BOSS_TRIBUTE_DIFFICULTY_MULTIPLIER = {
    normal: 1,
    heroic: 1.3,
    nightmare: 1.6,
};
export function computeTribute(waveNumber, difficulty) {
    const mult = BOSS_TRIBUTE_DIFFICULTY_MULTIPLIER[difficulty];
    return Math.round(BOSS_TRIBUTE_BASE * waveNumber * mult);
}
export const BOSS_ANTI_STALL_TICKS = 45 * TICK_RATE;
export const BOSS_ANTI_STALL_REGEN_PER_TICK_PCT = 0.0005;
export const BOSS_INHERIT_BUFF_FALLBACK_PCT = 0.05;
//# sourceMappingURL=boss.js.map